module.exports = __webpack_public_path__ + "img/default.f1359f60.png";